export const ADD_SEARCH = 'searchObjects/ADD_SEARCH';
export const EDIT_SEARCH = 'searchObjects/EDIT_SEARCH';
export const REMOVE_SEARCH = 'searchObjects/REMOVE_SEARCH';
export const RECEIVE_SEARCH_OBJS = 'searchObjects/RECEIVE_SEARCH_OBJS';
export const RECEIVE_SEARCH = 'searchObjects/RECEIVE_SEARCH';
